<template>
  <BModal
    id="modal-tenant-invoice"
    ref="modal-tenant-invoice"
    hide-footer="hide-footer"
    size="lg"
  >
    <template slot="modal-title">
      Fatura
    </template>
    <template slot="default">
      <div
        class="embed-responsive embed-responsive-4by3"
        v-if="invoice"
      >
        <iframe
          class="embed-responsive-item"
          :src="invoice.url"
        />
      </div>
    </template>
  </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  mounted () {
    Bus.$on('tenantInvoice', (invoice) => this.open(invoice));
  },

  data () {
    return {
      invoice: null,
    };
  },

  methods: {
    open (invoice) {
      this.invoice = invoice;

      this.$refs['modal-tenant-invoice'].show();
    },

    duplicate () {
      //
    },

    print () {
      //
    },
  },
};
</script>
